import React, { FunctionComponent } from 'react';

import Button from '../../../../components/button';
import { MenuItem } from '../../types';
import css from './menu.css';

export type SettingsMenuProps = {
    menuItems: MenuItem[];
    selectedItem: MenuItem | null;
    onSelectedItemChange: (item: MenuItem) => void;
};

const SettingsMenu: FunctionComponent<SettingsMenuProps> = ({ selectedItem, onSelectedItemChange, menuItems }) => {
    return (
        <div className={css.Menu}>
            {menuItems.map((menuItem) => {
                const { title, color, icon, testId } = menuItem;

                return (
                    <Button
                        key={title()}
                        className={css.MenuButton}
                        view="neutral-transparent"
                        size="md"
                        width="max"
                        contentAlign="start"
                        isChecked={selectedItem === menuItem}
                        icon={
                            <div className={css.IconContainer} style={{ backgroundColor: color }}>
                                {icon}
                            </div>
                        }
                        onClick={() => onSelectedItemChange(menuItem)}
                        data-test-id={testId}
                    >
                        {title()}
                    </Button>
                );
            })}
        </div>
    );
};

export default SettingsMenu;
